<div class="container-fluid pb-3">
    @if (view$ | async; as view) {
        @if (!view.loading) {
            <div class="p-1 text-end mb-3">
                @if (hasMyBrunataService()) {
                    <button
                        type="button"
                        class="btn btn-outline-primary my-1 mx-2"
                        [disabled]="inviteInFlight()"
                        (click)="inviteAllConsumers()">
                        {{ 'actions_inviteAllResidents' | translate: 'online' : 'residents' }}
                    </button>
                }

                <button
                    type="button"
                    class="btn btn-outline-primary my-1"
                    [disabled]="isExporting() || view.value.collectionSize === 0"
                    (click)="exportConsumers(view.value)">
                    {{ 'actions_export' | translate: 'online' : 'systems' }}
                </button>

                <button
                    type="button"
                    class="btn btn-outline-primary my-1 mx-2"
                    (click)="resetFiltersAndSorting()">
                    {{ 'utilities_STANDARDSORTORDER' | translate }}
                </button>

                <div ngbDropdown class="d-inline-block" container="body" placement="bottom-right">
                    <button type="button" class="btn btn-primary" id="viewForm" ngbDropdownToggle>
                        {{ 'utilities_VIEW' | translate }}
                    </button>
                    <div ngbDropdownMenu aria-labelledby="viewForm">
                        <div class="px-4 py-3">
                            <div class="form-check mb-2">
                                <input
                                    type="checkbox"
                                    class="form-check-input"
                                    id="showPastCheck"
                                    [checked]="showPast()"
                                    (change)="toggleShowPast()" />
                                <label class="form-check-label" for="showPastCheck">
                                    {{ 'consumers_view_past' | translate: 'online' : 'ngonline' }}
                                </label>
                            </div>
                            <div class="form-check">
                                <input
                                    type="checkbox"
                                    class="form-check-input"
                                    id="showFutureCheck"
                                    [checked]="showFuture()"
                                    (change)="toggleShowFuture()" />
                                <label class="form-check-label" for="showFutureCheck">
                                    {{ 'consumers_view_future' | translate: 'online' : 'ngonline' }}
                                </label>
                            </div>

                            @if (showNoEmailFilter() || showNoPhoneFilter()) {
                                <hr class="my-2" />
                            }
                            @if (showNoEmailFilter()) {
                                <div class="form-check mb-2">
                                    <input
                                        type="checkbox"
                                        class="form-check-input"
                                        id="noEmailFilter"
                                        [checked]="filterSignal().noEmail"
                                        (change)="toggleNoEmail()" />
                                    <label class="form-check-label" for="noEmailFilter">
                                        {{
                                            'consumers_filter_noEmail'
                                                | translate: 'online' : 'ngonline'
                                        }}
                                    </label>
                                </div>
                            }
                            @if (showNoPhoneFilter()) {
                                <div class="form-check">
                                    <input
                                        type="checkbox"
                                        class="form-check-input"
                                        id="noPhoneFilter"
                                        [checked]="filterSignal().noPhone"
                                        (change)="toggleNoPhone()" />
                                    <label class="form-check-label" for="noPhoneFilter">
                                        {{
                                            'consumers_filter_noPhone'
                                                | translate: 'online' : 'ngonline'
                                        }}
                                    </label>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <app-residents-table
                [groupedLocations]="view.value.groupedLocations"
                [page]="page()"
                [pageSize]="pageSize()"
                [currentSorting]="sortingSignal()"
                [showPast]="view.value.showPast"
                [showFuture]="view.value.showFuture"
                [showOnlineAccess]="hasMyBrunataService()"
                [inviteInFlight]="inviteInFlight()"
                [expandedLocationIds]="expandedLocationIds()"
                (sort)="onSort($event)"
                (inviteConsumer)="inviteConsumer($event)"
                (editConsumer)="editConsumer($event)"
                (toggleLocationHistory)="toggleLocationHistory($event)">
                <app-residents-filter
                    filter-row-content
                    [showOnlineAccess]="hasMyBrunataService()"
                    [onlineAccessOptions]="onlineAccessOptions()"
                    [initialOnlineAccess]="filter$ | async | onlineAccess"
                    [initialFilter]="restoredFilter()"
                    [showNoEmailFilter]="showNoEmailFilter()"
                    [showNoPhoneFilter]="showNoPhoneFilter()"
                    (filterChanged)="onFilterChanged($event)"></app-residents-filter>
            </app-residents-table>

            <div class="text-center">
                <app-pagination
                    [collectionSize]="view.value.collectionSize"
                    [page]="page()"
                    (pageChange)="setPage($event)"
                    (pageSizeChange)="setPageSize($event)"
                    [pageSize]="pageSize()">
                </app-pagination>
            </div>
        } @else {
            <app-load />
        }
    } @else {
        <app-load />
    }
</div>
